// The three VITE_* keys (contracts BROWSER_ENV_KEYS). Vite inlines them into
// the public bundle, so none of them is a secret.
import type { BrowserEnvKey } from '@kima-hub/contracts';

export interface WebConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  apiBaseUrl: string;
}

export function readConfig(env: Readonly<Record<string, unknown>>): WebConfig {
  const read = (key: BrowserEnvKey): string => {
    const value = env[key];
    return typeof value === 'string' ? value.trim() : '';
  };
  const need = (key: BrowserEnvKey): string => {
    const value = read(key);
    if (!value) throw new Error(`missing ${key}`);
    return value;
  };
  return {
    supabaseUrl: need('VITE_SUPABASE_URL'),
    supabaseAnonKey: need('VITE_SUPABASE_ANON_KEY'),
    apiBaseUrl: need('VITE_API_BASE_URL'),
  };
}
